import React, { useCallback, useState } from "react"
import { MapView as View } from "@ciq/shared/pages/map/view"
import { EditButton } from "@ciq/shared/components/buttons"
import { Mappings } from "./components/mappings/view"

export default function MapView() {
  const [showMappings, setShowMappings] = useState(false)

  const toggleMappings = useCallback(() => {
    setShowMappings(old => !old)
  }, [])

  return (
    <View>
      <EditButton onClick={toggleMappings} />
      <Mappings show={showMappings} onHide={toggleMappings} />
    </View>
  )
}
